export const exportRouteActivityExcel = (data) => {
    const headerBg = '#10B981'; // Verde corporativo
    const headerColor = '#ffffff';

    // Iniciamos la tabla
    let html = `<table border="1" style="border-collapse: collapse; font-family: Arial, sans-serif; font-size: 12px; width: 100%; text-align: center; border: 1px solid #D1D5DB;">`;
    
    // 1. DIBUJAR CABECERAS
    html += `<thead><tr>`;
    const headers = [
        "Ciudad", "Ruta", "Conductor",
        "Horario Lunes", "Horas Lunes",
        "Horario Martes", "Horas Martes",
        "Horario Miércoles", "Horas Miércoles",
        "Horario Jueves", "Horas Jueves",
        "Horario Viernes", "Horas Viernes",
        "Horario Sábado", "Horas Sábado",
        "Horario Domingo", "Horas Domingo",
        "Horario Promedio Semanal", "Horas Semanal"
    ];
    
    headers.forEach(h => {
        html += `<th style="background-color: ${headerBg}; color: ${headerColor}; padding: 10px; border: 1px solid #D1D5DB; font-weight: bold;">${h}</th>`;
    });
    html += `</tr></thead><tbody>`;

    // 2. AGRUPAR LOS DATOS POR CIUDAD PARA CALCULAR LAS CELDAS UNIDAS (ROWSPAN)
    const grouped = data.reduce((acc, curr) => {
        if (!acc[curr.cityName]) acc[curr.cityName] = [];
        acc[curr.cityName].push(curr);
        return acc;
    }, {});

    // 3. DIBUJAR FILAS
    Object.entries(grouped).forEach(([cityName, routes]) => {
        // Calculamos cuántas filas en total ocupará esta ciudad (suma de todos los buses de todas sus rutas)
        let cityRowSpan = routes.reduce((sum, route) => sum + Math.max(route.buses.length, 1), 0);
        let isFirstCityRow = true;

        routes.forEach(route => {
            // Calculamos cuántas filas ocupará esta ruta (sus buses)
            let routeRowSpan = Math.max(route.buses.length, 1);
            let isFirstRouteRow = true;

            const buses = route.buses.length > 0 ? route.buses : [null];

            buses.forEach(bus => {
                html += `<tr>`;
                
                // Si es la primera fila de la ciudad, creamos la celda combinada verticalmente
                if (isFirstCityRow) {
                    html += `<td rowspan="${cityRowSpan}" style="vertical-align: middle; border: 1px solid #D1D5DB; font-weight: bold; font-size: 14px; background-color: #F3F4F6;">${cityName}</td>`;
                    isFirstCityRow = false;
                }
                
                // Si es la primera fila de la ruta, creamos la celda combinada verticalmente
                if (isFirstRouteRow) {
                    html += `<td rowspan="${routeRowSpan}" style="vertical-align: middle; border: 1px solid #D1D5DB; font-weight: bold; background-color: #F9FAFB;">${route.routeName}</td>`;
                    isFirstRouteRow = false;
                }

                // Llenar datos del autobús
                if (bus) {
                    html += `<td style="border: 1px solid #D1D5DB; text-align: left; padding-left: 5px;"><b>${bus.driver}</b><br/><span style="color: #6B7280; font-size: 10px;">Bus ${bus.busId} (${bus.plate})</span></td>`;
                    
                    // 🔥 AQUÍ ESTÁ EL ARREGLO: Cambiamos day.schedule por day.shifts.join(" | ")
                    bus.streak.forEach(day => {
                        const scheduleText = day.active ? day.shifts.join(" | ") : 'Descanso';
                        html += `<td style="border: 1px solid #D1D5DB; color: ${day.active ? '#374151' : '#9CA3AF'};">${scheduleText}</td>`;
                        html += `<td style="border: 1px solid #D1D5DB; color: ${day.active ? '#10B981' : '#9CA3AF'}; font-weight: bold;">${day.active ? day.hours : '0'}</td>`;
                    });
                    
                    html += `<td style="border: 1px solid #D1D5DB;">${bus.avgSchedule}</td>`;
                    html += `<td style="border: 1px solid #D1D5DB; font-weight: bold; color: #10B981; font-size: 14px; background-color: #ECFDF5;">${bus.totalHours}</td>`;
                } else {
                    html += `<td style="border: 1px solid #D1D5DB; color: #EF4444;">Sin unidades activas</td>`;
                    for(let i=0; i<16; i++) html += `<td style="border: 1px solid #D1D5DB;">-</td>`;
                }
                html += `</tr>`;
            });
        });
    });

    html += `</tbody></table>`;

    // Plantilla XML de Excel que previene errores de caracteres latinos (ñ, á, é) y forzar que lea como texto
    const htmlTemplate = `
        <html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
        <head>
            <meta charset="utf-8" />
            <style> td { mso-number-format:"\\@"; } /* Evita que Excel cambie horas a formatos de fecha raros */ </style>
        </head>
        <body>${html}</body>
        </html>
    `;
    
    // Descarga nativa
    const blob = new Blob([htmlTemplate], { type: 'application/vnd.ms-excel' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Actividad_Rutas.xls';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};